import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/_services/helpers.service';

@Component({
  selector: 'app-modal-pdf',
  templateUrl: './modal-pdf.component.html',
  styleUrls: ['./modal-pdf.component.scss'],
})
export class ModalPdfComponent implements OnInit {
  @Input('src') src: any;
  pdfZoom : number = 1;
  pdfRotate : number = 0;

  constructor(private modalController: ModalController, public helper: HelpersService) {}

  ngOnInit() {}

  ionViewDidEnter() {
  }

  zoomIn() {
    this.pdfZoom = this.pdfZoom + 0.25;
  }

  zoomOut() {
    this.pdfZoom = this.pdfZoom - 0.25;
  }

  rotate() {
    if(this.pdfRotate > 270) {
      this.pdfRotate = 0;
    } 
    this.pdfRotate = this.pdfRotate + 90;
  }

  close() {
    this.modalController.dismiss();
  }
  
  onProgress(ev) {
    console.log(ev);
  }
}
